import i18next from "i18next";

interface UserCredentials {
  password: string;
  verifyPassword: string;
}

export const getPasswordRules = (userCredentials: UserCredentials) => [
  {
    rule: i18next.t("auth.create.password.characters"),
    isValid: userCredentials.password.length >= 8,
  },
  {
    rule: i18next.t("auth.create.password.uppercase"),
    isValid: /^(?=.*[A-Z])/.test(userCredentials.password),
  },
  {
    rule: i18next.t("auth.create.password.number"),
    isValid: /^(?=.*\d)/.test(userCredentials.password),
  },
  {
    rule: i18next.t("auth.create.password.lowercase"),
    isValid: /^(?=.*[a-z])/.test(userCredentials.password),
  },
  {
    rule: i18next.t("auth.create.password.match"),
    isValid:
      userCredentials.password !== "" &&
      userCredentials.password === userCredentials.verifyPassword,
  },
  {
    rule: i18next.t("auth.create.password.special"),
    isValid: /[@#$%^&+=!]/.test(userCredentials.password),
  },
];
